import React from 'react';
import { Link } from 'react-router-dom';
import { prop } from 'ramda';
import { NumberOutlined } from '@ant-design/icons';
import { Row, Col } from 'antd';
import moment from 'moment';
import { getStatusLabel } from '../../lib/status';
import ConfirmButton from '../ConfirmButton';

const VersionsTreeItem = ({
  name,
  dates,
  version,
  editLink,
  isStyle = false,
  uuid,
  archiveLabel,
  restoreLabel,
  descriptionArchive,
  isArchived,
  userCanEdit,
  setArchiveStatus,
  archiveLoading
}) => {
  const styles = {
    width: '100%',
    display: 'inline-flex',
    color: 'var(--flexi-text)',
    fontSize: '14px'
  };
  const status = isArchived ? 'archived' : prop('status', version);

  return (
    // eslint-disable-next-line no-restricted-syntax
    <Row align="middle" style={styles}>
      <Col span={isStyle ? 7 : 8}>
        {!isArchived
          ? (
            <Link to={editLink}>
              {name}
            </Link>
          )
          : name
        }
      </Col>

      {isStyle && (
        <Col span={8}>
          <div>
            <NumberOutlined className="mr-2 text-lg" />
            {uuid}
          </div>
        </Col>
      )}

      <Col span={isStyle ? 3 : 4}>
        <p>{`Version ${prop('major', version)}.${prop('minor', version)}`}</p>
        <p className="text-xs text-flexi-placeholder">{moment(prop('lastUpdate', dates)).format('DD/MM/YY')}</p>
      </Col>

      <Col span={isStyle ? 3 : 7}>
        <div className={`badge ${status}`}>
          {getStatusLabel(status)}
        </div>
      </Col>

      {!isStyle && isArchived && (
        <Col span={3}>
          <p className="text-right text-xs text-flexi-placeholder">Date d'archive : {moment(prop('lastUpdate', dates)).format('DD/MM/YY')}</p>
        </Col>
      )}
      
      {!isStyle && userCanEdit && (
        <Col span={isArchived ? 2 : 5} className="flex justify-end">
          <ConfirmButton
            placement="topRight"
            title={isArchived ? restoreLabel : archiveLabel}
            onConfirm={setArchiveStatus}
            buttonText={isArchived ? 'Rétablir' : 'Archiver'}
            buttonType="text"
            loading={archiveLoading}
          >{isArchived ? '' : descriptionArchive}
          </ConfirmButton>
        </Col>
      )}
    </Row>
  );
};

export default VersionsTreeItem;
